import React from "react";

const FiltersIcon = props => {
    const { fill, classname } = props

    return (
        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill={fill} className={ (classname !== undefined ? classname : "") }>
            <g>
                <path d="m187.304 252.717c8.045 11.642 5.64 1.941 5.64 233.997 0 20.766 23.692 32.651 40.39 20.23 71.353-53.797 85.609-58.456 85.609-83.619 0-169.104-1.971-159.594 5.64-170.608l115.869-157.718h-369.016z"></path><path d="m484.221 12.86c-4.14-7.93-12.26-12.86-21.199-12.86h-414.156c-19.305 0-30.664 21.777-19.59 37.6.091.152-1.257-1.693 20.12 27.4h413.095c18.217-24.793 30.394-35.505 21.73-52.14z">
                </path>
            </g>
        </svg>
    )
}

export default FiltersIcon;
